import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import { AuthenticationState, AzureAD } from "react-aad-msal";
import reportWebVitals from './reportWebVitals';
import { authProvider } from './authProvider';
import UnauthorizedPage from './client/Components/UnauthorizedPage';
import {Provider} from 'react-redux'
import store from './client/redux/store'

const azureAuth = true;
const noAuthAccount = {
    "account": {
        "accountIdentifier": "ea8e3b32-ee8c-4bfd-811a-2d879a59b389",
        "homeAccountIdentifier": "NTRjNzlhYTktOWJiYS00OWZhLTg1ZDUtNDQxNTU1NjlmZTAy.OGM2NDJkMWQtZDcwOS00N2IwLWFiMTAtMDgwYWYxMDc5OGZi",
        "userName": "smitha.vizhi@toyota.com",
        "name": "John Doe (TMS)",
        "idToken": {
            "aud": "d1d58275-7e4f-4e20-bfe5-7c13893c0c61",
            "iss": "https://login.microsoftonline.com/b7be26fb-0007-4e34-9f39-088aa7bc74b0/v2.0",
            "iat": 1645539892,
            "nbf": 1645539892,
            "exp": 1645543792,
            "aio": "AUQAu/8TAAAAEH8gOFz8PNPylhp5QvlHWlRDRtYmpehtlNd0FUppMfbN+WSEb8AgTPu+GsOIYTDFYbfPHdfKrajl8udOx/1ttg==",
            "idp": "https://sts.windows.net/8c642d1d-d709-47b0-ab10-080af10798fb/",
            "name": "Smitha Vizhi (TMS)",
            "nonce": "76341862-3e15-468d-bf95-f5821c47d4d7",
            "oid": "ea8e3b32-ee8c-4bfd-811a-2d879a59b389",
            "preferred_username": "smitha.vizhi@toyota.com",
            "rh": "0.AVEA-ya-twcANE6fOQiKp7x0sHWC1dFPfiBOv-V8E4k8DGFRADA.",
            "sub": "QbwsL6hQ_KIOB-ALkNRtZTQcYKwDG47tYs7rkHAaNog",
            "tid": "b7be26fb-0007-4e34-9f39-088aa7bc74b0",
            "uti": "a6MAJnOk00WOf_JTn_A0AQ",
            "ver": "2.0"
        },
        "idTokenClaims": {
            "aud": "d1d58275-7e4f-4e20-bfe5-7c13893c0c61",
            "iss": "https://login.microsoftonline.com/b7be26fb-0007-4e34-9f39-088aa7bc74b0/v2.0",
            "iat": 1645539892,
            "nbf": 1645539892,
            "exp": 1645543792,
            "aio": "AUQAu/8TAAAAEH8gOFz8PNPylhp5QvlHWlRDRtYmpehtlNd0FUppMfbN+WSEb8AgTPu+GsOIYTDFYbfPHdfKrajl8udOx/1ttg==",
            "idp": "https://sts.windows.net/8c642d1d-d709-47b0-ab10-080af10798fb/",
            "name": "Smitha Vizhi (TMS)",
            "nonce": "76341862-3e15-468d-bf95-f5821c47d4d7",
            "oid": "ea8e3b32-ee8c-4bfd-811a-2d879a59b389",
            "preferred_username": "smitha.vizhi@toyota.com",
            "rh": "0.AVEA-ya-twcANE6fOQiKp7x0sHWC1dFPfiBOv-V8E4k8DGFRADA.",
            "sub": "QbwsL6hQ_KIOB-ALkNRtZTQcYKwDG47tYs7rkHAaNog",
            "tid": "b7be26fb-0007-4e34-9f39-088aa7bc74b0",
            "uti": "a6MAJnOk00WOf_JTn_A0AQ",
            "ver": "2.0"
        },
        "environment": "https://login.microsoftonline.com/b7be26fb-0007-4e34-9f39-088aa7bc74b0/v2.0"
    },
    "jwtIdToken": "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6Ik1yNS1BVWliZkJpaTdOZDFqQmViYXhib1hXMCJ9.eyJhdWQiOiJkMWQ1ODI3NS03ZTRmLTRlMjAtYmZlNS03YzEzODkzYzBjNjEiLCJpc3MiOiJodHRwczovL2xvZ2luLm1pY3Jvc29mdG9ubGluZS5jb20vYjdiZTI2ZmItMDAwNy00ZTM0LTlmMzktMDg4YWE3YmM3NGIwL3YyLjAiLCJpYXQiOjE2NDU1Mzk4OTIsIm5iZiI6MTY0NTUzOTg5MiwiZXhwIjoxNjQ1NTQzNzkyLCJhaW8iOiJBVVFBdS84VEFBQUFFSDhnT0Z6OFBOUHlsaHA1UXZsSFdsUkRSdFltcGVodGxOZDBGVXBwTWZiTitXU0ViOEFnVFB1K0dzT0lZVERGWWJmUEhkZktyYWpsOHVkT3gvMXR0Zz09IiwiaWRwIjoiaHR0cHM6Ly9zdHMud2luZG93cy5uZXQvOGM2NDJkMWQtZDcwOS00N2IwLWFiMTAtMDgwYWYxMDc5OGZiLyIsIm5hbWUiOiJTbWl0aGEgVml6aGkgKFRNUykiLCJub25jZSI6Ijc2MzQxODYyLTNlMTUtNDY4ZC1iZjk1LWY1ODIxYzQ3ZDRkNyIsIm9pZCI6ImVhOGUzYjMyLWVlOGMtNGJmZC04MTFhLTJkODc5YTU5YjM4OSIsInByZWZlcnJlZF91c2VybmFtZSI6InNtaXRoYS52aXpoaUB0b3lvdGEuY29tIiwicmgiOiIwLkFWRUEteWEtdHdjQU5FNmZPUWlLcDd4MHNIV0MxZEZQZmlCT3YtVjhFNGs4REdGUkFEQS4iLCJzdWIiOiJRYndzTDZoUV9LSU9CLUFMa05SdFpUUWNZS3dERzQ3dFlzN3JrSEFhTm9nIiwidGlkIjoiYjdiZTI2ZmItMDAwNy00ZTM0LTlmMzktMDg4YWE3YmM3NGIwIiwidXRpIjoiYTZNQUpuT2swMFdPZl9KVG5fQTBBUSIsInZlciI6IjIuMCJ9.ShDtl9vV0Tury9OduA5RPwStk2MpEHokZsAi3O10rRnQdIEQCXL8Gr1TD7Aue5Vdb31hC_l5Im3k42IFmfM8-GgcD1k2c27Y-FD-vYRsyzJHqqeP_4ty-hn0zBnE6l-cIUqWfsCbIqslz-zPZCsV98YCcyl4mQvuNbp7QnfC1QRu1Y2h4EDoHaPfdaPKv-CiCCjXd758eRKrdQwMpIU_0E2nU8csrmMYkYx5bf03wAZl7JCSCkA-sT06l1H1ugKuA-EYw6M2qU5KOX0hRoq1XkCngM7HHyUNfhkVqsnCdQMIacVqmRe3xWrvRGA4nraRrC-9rn6TUgFdJ5qORRKjBA"
}

ReactDOM.render(
  <React.StrictMode>
    {
    !azureAuth?
    <Provider store={store}><App accountInfo={noAuthAccount} logout={()=>{console.log('logout clicked')}}/></Provider>:
    <AzureAD provider={ authProvider } forceLogin={ true }>
            { ({
                    login,
                    logout,
                    authenticationState,
                    error,
                    accountInfo
                }:any) => {
                //  console.log('token',accountInfo.jwtIdToken)
                console.log(authenticationState);
                switch (authenticationState) {
                    case AuthenticationState.Authenticated:
                        console.log(accountInfo);
                        console.log('un',accountInfo.account.name)
                        return <Provider store={store}><App accountInfo={accountInfo} logout={logout}/></Provider>
                    case AuthenticationState.Unauthenticated:
                        console.log('error',accountInfo);
                        return <UnauthorizedPage/>
                    case AuthenticationState.InProgress:
                        return <p>Logging in</p>
                    default:
                        return <></>;
                }
            } }
        
        </AzureAD>
        }
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
